import { STORAGE_VUEX_ACCOUNT_KEY } from '@motionelements/core/src/app.constants';
import VuexPersistence from 'vuex-persist';

export default new VuexPersistence({
  key: STORAGE_VUEX_ACCOUNT_KEY,
  storage: window.sessionStorage,
  reducer: ({ favorites, cart, user }) => ({
    hash: `${user.jwt.id}|${user.language}|${user.currencyCode}|202102`,
    user: user,
    favorites: {
      defaultFolder: {
        totalCount: _.get(favorites, 'defaultFolder.totalCount'),
      },
    },
    cart: cart,
  }),
  filter: (mutation) => {
    console.log(mutation);
    return [
      'user/setJwtId',
      'user/setMember',
      'user/setLanguage',
      'favorites/setDefaultFolderTotalCount',
      'cart/setCartItems',
      'cart/clearCart',
    ].includes(mutation.type);
  },
});
